/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Pos_Invoice_TabInputs */

const vi_pos_invoice_tab = /** @type {(inputs: Pos_Invoice_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn bán ${i?.number}`)
};

/**

* @param {Pos_Invoice_TabInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_invoice_tab = /** @type {((inputs: Pos_Invoice_TabInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Invoice_TabInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_invoice_tab(inputs)
});